import $ from "jquery";
import { ajaxFormFactory } from "../ajax/ajaxForm";
$(() => {
    const password = $(".password");
    const email = $(".email-address");
    const verificationCode = $(".verification-code");
    const focusPassword = () => email.val() && password.trigger("focus");
    const focusVerificationCode = () => verificationCode.trigger("focus");
    focusPassword();
    focusVerificationCode();
    const [signInForm] = ajaxFormFactory.getModels($("#signin-form"));
    const [samlSignInForm] = ajaxFormFactory.getModels($("#saml-signin-form"));
    const [verificationForm] = ajaxFormFactory.getModels($("#verification-form"));
    signInForm === null || signInForm === void 0 ? void 0 : signInForm.on("failure", () => {
        password.val("");
        focusPassword();
    });
    samlSignInForm === null || samlSignInForm === void 0 ? void 0 : samlSignInForm.on("failure", () => email.trigger("focus"));
    verificationForm === null || verificationForm === void 0 ? void 0 : verificationForm.on("failure", () => {
        verificationCode.val("");
        focusVerificationCode();
    });
});
